export default __webpack_public_path__ + "static/media/menu_orders.553f4d2e.svg";